import { useHirerAuth } from '@seek/hirer-auth-react';
import type { ChangeEvent } from 'react';

import { TRACKING_ORIGIN } from 'src/app/shared/constants/headerFooterTracking';
import { useConfig } from 'src/app/shared/hooks/useConfig';
import { useAnalyticsTracking } from 'src/app/v2/hooks/useAnalyticsTracking';
import { useHeaderFooterContext } from 'src/app/v2/hooks/useHeaderFooterContext';
import { MainLayout } from 'src/app/v2/layouts/main';

import { ErrorSectionRecoverable } from './components/ErrorSectionRecoverable';

export const ErrorPageRecoverable = () => {
  const headerFooterContext = useHeaderFooterContext();

  const { getSite, getLocale } = useConfig();
  const { trackingAdapter } = useAnalyticsTracking();
  const { authenticated } = useHirerAuth();

  const onToggleButtonClick = (event: ChangeEvent) => {
    const trackingEvent = event.target.getAttribute('data-analytics');

    if (trackingEvent) {
      const eventData = {
        eventName: trackingEvent,
        objectInteraction: TRACKING_ORIGIN.HEADER,
      };
      trackingAdapter.sendLinkEvent(eventData);
    }
  };

  return (
    <MainLayout
      headerFooterContext={
        authenticated ? headerFooterContext : { identityContext: null }
      }
      site={getSite()}
      locale={getLocale()}
      basicHeader={true}
      onToggleButtonClick={onToggleButtonClick}
    >
      <ErrorSectionRecoverable />
    </MainLayout>
  );
};
